import { animate, style, transition, trigger } from "@angular/animations";
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { GlobalService } from "src/app/services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { USERDataService } from "src/app/services/user/user-data.service";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { AppUtil } from "src/app/utils/app.util";

@Component({
	selector: "app-billing-account",
	templateUrl: "./billing-account.component.html",
	styleUrls: ["./billing-account.component.css"],
	animations: [
		trigger("slideDownUp", [
			transition(":enter", [style({ height: 0 }), animate(200)]),
			transition(":leave", [animate(200, style({ height: 0 }))])
		])
	]
})
export class BillingAccountComponent implements OnInit, OnDestroy {
	constructor(
		public router: Router,
		public globalService: GlobalService,
		public userStoreService: USERStoreService,
		public dmvStoreService: DMVStoreService,
		public userDataService: USERDataService,
		public megStoreService: MEGStoreService,
		private cd: ChangeDetectorRef
	) {}

	public isRegistrationsVisible: boolean = false;

	public errorMessage: string = "";
	public isloading: boolean = false;
	public sucessMessage: string = "";
	public removeAccountName: string = "";
	public openConfirmModel: boolean = false;
	public billingAccountIDToDelete: number = null;
	ngOnInit() {}
	public close() {
		this.back();
	}
	public back() {
		this.router.navigate(["profile"], { skipLocationChange: true });
	}
	ngOnDestroy() {
		this.userStoreService.outComeText = "";
	}

	public toggle(type) {
		switch (type) {
			case "registrations":
				this.isRegistrationsVisible = !this.isRegistrationsVisible;
				break;
			default:
		}
	}
	public getLicensePlate(data) {
		const billingAccountFields = data.billingAccountFields.filter(function(
			item
		) {
			return item.fieldID === 1;
		});
		return billingAccountFields[0];
	}
	public getDec(data) {
		const billingAccountFields = data.billingAccountFields.filter(function(
			item
		) {
			return item.fieldID === 3;
		});
		return billingAccountFields[0];
	}
	public openModel(data) {
		this.billingAccountIDToDelete = data.billingAccountID;
		this.removeAccountName =
			this.getLicensePlate(data).name + " " + this.getLicensePlate(data).value;
		this.openConfirmModel = true;
	}
	public closePopup() {
		this.openConfirmModel = false;
	}
	public delete() {
		this.errorMessage = "";
		this.sucessMessage = "";
		this.openConfirmModel = false;
		this.isloading = true;
		this.userStoreService.outComeText = "";
		this.userDataService
			.deleteBillingAccount(
				this.dmvStoreService.sessionGUID,
				this.userStoreService.getUserProfile().megUserGUID,
				this.billingAccountIDToDelete
			)
			.subscribe(
				response => {
					AppUtil.log("deleteBillingAccount() ==>", response);
					if (response) {
						this.isloading = false;
						if (response.statusCode === 200) {
							this.sucessMessage = response.OutcomeText;
							const userProfile = this.userStoreService.getUserProfile();
							userProfile.billingAccounts.dmvAccounts.splice(
								userProfile.billingAccounts.dmvAccounts.findIndex(
									a => a.billingAccountID === this.billingAccountIDToDelete
								),
								1
							);
							this.userStoreService.setUserProfileFromResponse(
								response,
								userProfile
							);
						} else {
							this.errorMessage = response.OutcomeText;
							window.scrollTo(0, 0);
						}
						this.cd.detectChanges();
					}
				},
				error => {
					AppUtil.log("deleteBillingAccount()==> error:", error);
					if (
						error.name === "HttpErrorResponse" ||
						error.name === "TimeoutError" ||
						(error["status"] && error["status"] !== 200)
					) {
						this.errorMessage =
							"Internal system error.  Please retry.  If this problem persists, please contact our support team for assistance.";

						this.isloading = false;
						window.scrollTo(0, 0);
						this.cd.markForCheck();
					}
				}
			);
	}
}
